export const stringToHash = (string) => string?.toLowerCase().replace(/ /g, '_')
